import type { EdgeTypes } from '@xyflow/react';

// Using default edge types for now. Custom edge renderers can be added here later.
export const edgeTypes: EdgeTypes = {};
